import { differenceInDays, differenceInHours, differenceInMinutes } from 'date-fns';

export const formatDurationString = (end: number | Date, start: number | Date): string => {
  const daysAgo = differenceInDays(end, start);
  if (daysAgo === 0) {
    const hoursAgo = differenceInHours(end, start);
    return hoursAgo === 0
      ? differenceInMinutes(end, start) === 1
        ? `${differenceInMinutes(end, start)} minute`
        : `${differenceInMinutes(end, start)} minutes`
      : hoursAgo === 1
        ? `${hoursAgo} hour`
        : `${hoursAgo} hours`;
  }
  if (daysAgo === 1) {
    return `${daysAgo} day`;
  }
  return `${daysAgo} days`;
};
